var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFold1Decoration2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 759,
    height: 580,
    viewBox: "0 0 759 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M758 39.3495C627.599 -82.6863 519.529 114.937 190.55 235.961C-138.43 356.986 56.9463 408.276 74.6649 411.877C92.3835 415.479 416.488 407.1 390.5 521.25C364.512 635.4 623.313 555.01 687 496.07C750.687 437.129 758 329.543 758 329.543",
    stroke: "#CDD6FF",
    strokeWidth: 2,
    strokeDasharray: "10 10"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 31,
    r: 6,
    fill: "#A7B7FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 407,
    r: 6,
    fill: "#A7B7FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFold1Decoration2);
export default __webpack_public_path__ + "static/media/fold-1-decoration2.af9254b946359632cd44789f11e8b3e7.svg";
export { ForwardRef as ReactComponent };